import { render, staticRenderFns } from "./YouHaveBookedLessonNotification.vue?vue&type=template&id=31f0b10e&"
import script from "./YouHaveBookedLessonNotification.vue?vue&type=script&lang=js&"
export * from "./YouHaveBookedLessonNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports